// src/components/DateField.tsx
import React from 'react';
import { Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-solid-svg-icons';

interface DateFieldProps {
  date: Date | string | number | null | undefined; // Allow for string or number types that can be converted to Date
}

const DateField: React.FC<DateFieldProps> = ({ date }) => {
  // Function to check if the date is valid
  const isValidDate = (dateToCheck: any): dateToCheck is Date => {
    return dateToCheck instanceof Date && !isNaN(dateToCheck.getTime());
  };

  // Convert the date prop to a Date object if it's not already
  const convertToDate = (date: Date | string | number | null | undefined): Date | null => {
    if (date instanceof Date) {
      return isValidDate(date) ? date : null;
    }
    if (typeof date === 'string' || typeof date === 'number') {
      const convertedDate = new Date(date);
      return isValidDate(convertedDate) ? convertedDate : null;
    }
    return null;
  };

  const validDate = convertToDate(date);

  if (!validDate) {
    console.error('Invalid date provided:', date);
    return <Badge bg="danger">Invalid Date</Badge>;
  }

  const now = new Date();
  const diffInMilliseconds = now.getTime() - validDate.getTime();
  const minutesDifference = Math.floor(diffInMilliseconds / (1000 * 60));

  const getBadgeVariant = () => {
    if (minutesDifference > 60) {
      return 'danger';
    } else if (minutesDifference > 15) {
      return 'warning';
    } else {
      return 'success';
    }
  };

  return (
    <Badge bg={getBadgeVariant()} className='p-2'>
      <FontAwesomeIcon icon={faClock} /> {validDate.toLocaleString()}
    </Badge>
  );
};

export default DateField;
